var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWalletThunder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_27418_114925)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87177 10.3742H8.12675C8.81043 10.3742 9.15227 10.3742 9.33061 10.5977C9.50896 10.8212 9.4348 11.1566 9.28649 11.8276L8.90497 13.5534C8.71019 14.4345 8.6128 14.8751 8.8156 14.9808C9.0184 15.0864 9.32039 14.7525 9.92437 14.0846L12.9995 10.6843C13.3843 10.2587 13.5768 10.0459 13.6041 9.86843C13.6396 9.63788 13.5383 9.40766 13.3447 9.27898C13.1957 9.17994 12.9096 9.17994 12.3375 9.17994C11.8848 9.17994 11.6585 9.17994 11.5197 9.09836C11.3392 8.99233 11.2274 8.79875 11.2254 8.58862C11.2238 8.42694 11.3361 8.22942 11.5607 7.83438L12.1562 6.78679C12.6079 5.99215 12.8337 5.59483 12.662 5.29742C12.4903 5 12.0351 5 11.1247 5H9.96387C9.21441 5 8.83968 5 8.54443 5.19288C8.24918 5.38577 8.09699 5.73 7.7926 6.41846L6.78614 8.6949C6.45136 9.45211 6.28397 9.83072 6.45965 10.1025C6.63533 10.3742 7.04748 10.3742 7.87177 10.3742Z",
    strokeWidth: 0.833333,
    strokeLinejoin: "round",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27418_114925",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWalletThunder);
export default __webpack_public_path__ + "static/media/ic-wallet-thunder.fe0e33f7ba4a31577645e60ce8e4eed3.svg";
export { ForwardRef as ReactComponent };